import { GoogleLogin } from '@react-oauth/google';

interface Props {
  onCredential: (credential: string) => void;
  onError?: () => void;
}

export function GoogleSignInButton({ onCredential, onError }: Props): JSX.Element {
  return (
    <GoogleLogin
      onSuccess={(res) => {
        if (res.credential) onCredential(res.credential);
      }}
      onError={() => onError?.()}
      theme="filled_blue"
      shape="pill"
      width="356"
    />
  );
}
